export function getCookie(name: string): string {
  const cookiePattern = new RegExp('(^|;)[ ]*' + name + '=([^;]*)')
  const cookieMatch = cookiePattern.exec(document.cookie)
  return cookieMatch ? decodeURIComponent(cookieMatch[2]) : ''
}

export function setCookie(name: string, value: any, maxAge?: number): void {
  let expiredTime: Date
  let cookie: string = name + '=' + encodeURIComponent(value) + ';'

  if (maxAge) {
    expiredTime = new Date()
    expiredTime.setTime(expiredTime.getTime() + maxAge)
    cookie += `expires=${expiredTime.toUTCString()}`
  }

  document.cookie = cookie
}

export function uuid(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'

  let id = ''
  let i = 0
  for (let l = chars.length; i < 16; i++) {
    id += chars.charAt(Math.floor(Math.random() * l))
  }

  return id
}
